import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { getLanguage } from "../Managers/dataProvider";
import { ReportDetailModel } from "../Managers/dataStructures";
import { Table, TH, TD, TR } from "../../../AuxComponents/";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
  },
  header: {
    backgroundColor: "#FFFFFF",
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
  },
  comment_title: {
    marginTop: "10px",
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    lineHeight: "1.25",
  },
  comment: {
    marginTop: "2px",
    paddingTop: "2px",
    paddingLeft: "2px",
    paddingRight: "2px",
    paddingBottom: "2px",
    borderWidth: 1,
    borderColor: "#d1d5db",
    borderRadius: "5.0",
    backgroundColor: "#E4E4E4",
  },
  comment_text: {
    fontWeight: "500",
    fontSize: "12px",
    color: "#111827",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
  table: {
    marginTop: "25px",
  },
  tableHeader: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
  tableCell: {
    fontWeight: "500",
    fontSize: "12px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
});

interface PDFReportDailyProps {
  dateString: string;
  department: string;
  signatory: string;
  total_hours: string | undefined;
  comment: string;
  array_reports: ReportDetailModel[];
}

export default function PDFReportDaily(props: PDFReportDailyProps) {
  const isEnglish = getLanguage();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View>
            <View>
              <Text style={styles.title}>
                {isEnglish
                  ? "Report: Daily Branch"
                  : "Bericht: Filialtagesbericht"}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Date: " : "Datum: ") + props.dateString}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Branch: " : "Filiale: ") + props.department}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Branch manager: " : "Filial-/Schichtleiter: ") +
                  props.signatory}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Total hours: " : "Gesamtarbeitsstunden: ") +
                  props.total_hours}
              </Text>
              <Text style={styles.comment_title}>
                {isEnglish
                  ? "Branch Manager's comments: "
                  : "Anmerkungen des Filial-/Schichtleiters: "}
              </Text>
              <View style={styles.comment}>
                <Text style={styles.comment_text}>{props.comment}</Text>
              </View>
            </View>
            <View></View>
            <View style={styles.table}>
              <Table>
                <TH>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Name" : "Name"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Employee ID" : "Mitarbeiter ID"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Start Time" : "Arbeitsbeginn"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "End Time" : "Arbeitsende"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Total Hours" : "Gesamtarbeitszeit"}
                    </Text>
                  </TD>
                </TH>
                {props.array_reports.map((x) => CellReportDetail(x))}
              </Table>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

function CellReportDetail(item: ReportDetailModel) {
  return (
    <TR key={item.user.user_id}>
      <TD>
        <Text style={styles.tableCell}>
          {item.user.first_name + " " + item.user.last_name}
        </Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>
          {" "}
          {item.user.employee_id !== null
            ? item.user.employee_id
            : "Not Assigned"}
        </Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>{item.start_time}</Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>{item.end_time}</Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>{item.working_hours}</Text>
      </TD>
    </TR>
  );
}
